<template>
    <div class="article-venue-description">
        <p>
            Our Tuesday night West Coast Swing classes are held at
            <a
                href="https://www.google.co.uk/maps/place/St+Chad%E2%80%99s+Parish+Centre/@53.8285929,-1.5866954,17z/data=!3m1!4b1!4m5!3m4!1s0x4879593941154ce9:0xfdc33bf1b120c29f!8m2!3d53.8285983!4d-1.5844973"
                target="_blank"
                rel="noopener noreferrer nofollow"
                >St Chad’s Parish Centre</a
            >. It's on Otley Road in Far Headingley, just next door to the BP garage at the start of the Otley Run.
        </p>
        <p>
            There are great bus routes from all over Leeds to the venue, and if you're driving we have a free car park
            on site. Just head down and we'll explain everything.
        </p>
    </div>
</template>

<script>
export default {
    name: 'ArticleVenueDescription',
};
</script>
